function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.23 37.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.76,13.59C43.64,8.51,36.55,0,24.11,0S4.59,8.51,1.47,13.59A9.88,9.88,0,0,0,1.47,24C4.59,29,11.68,37.54,24.11,37.54S43.64,29,46.76,24A9.88,9.88,0,0,0,46.76,13.59Zm-3.43,8.26C40.65,26.2,34.6,33.53,24.11,33.53S7.57,26.2,4.9,21.85a5.84,5.84,0,0,1,0-6.16C7.57,11.34,13.63,4,24.11,4s16.54,7.31,19.22,11.67A5.84,5.84,0,0,1,43.33,21.85Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.11,8.73a10,10,0,1,0,10,10A10,10,0,0,0,24.11,8.73Zm0,16.07a6,6,0,1,1,6-6A6,6,0,0,1,24.11,24.8Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ee2b2b19.svg";
export { ForwardRef as ReactComponent };